/**
 * 強化された検索機能
 *
 * 2025-12-04: 検索サジェスト機能を一時無効化
 * - 商品数が10万点以上になったら再実装予定
 * - 英語版で日本語が表示される問題
 * - 検索結果が出ない問題
 */

(function() {
  'use strict';

  // 🚫 検索サジェスト機能を無効化（商品数10万点以上で再実装予定）
  // 基本の検索フォーム送信のみ有効
  return;

  // 検索履歴の最大保存件数
  const MAX_HISTORY_ITEMS = 5;

  // ===========================================
  // 類義語辞書（Synonym Dictionary）
  // 検索クエリを展開して関連結果を表示
  // ===========================================
  const SYNONYM_DICTIONARY = {
    // === 感情・表情 ===
    '怒り': ['怒っている', '激怒', '怒り顔', 'イライラ', '不機嫌', '腹立ち', 'angry', 'anger'],
    '怒る': ['怒っている', '激怒', '怒り', 'イライラ', '不機嫌', 'angry'],
    '悲しみ': ['悲しい', '泣く', '涙', '悲しげ', '悲痛', 'sad', 'sadness', 'crying'],
    '悲しい': ['悲しみ', '泣く', '涙', '悲しげ', 'sad'],
    '喜び': ['嬉しい', '喜ぶ', '笑顔', '幸せ', 'happy', 'joy', 'smile'],
    '嬉しい': ['喜び', '喜ぶ', '笑顔', '幸せ', 'happy'],
    '悩み': ['悩む', '悩んでいる', '困惑', '考え込む', '苦悩', 'worried', 'troubled'],
    '悩む': ['悩み', '悩んでいる', '困惑', '考え込む', 'worried'],
    '驚き': ['驚く', 'びっくり', '驚愕', 'ショック', 'surprised', 'shock'],
    '驚く': ['驚き', 'びっくり', '驚愕', 'surprised'],
    '笑顔': ['笑う', '微笑み', '笑い', 'スマイル', 'smile', 'laugh'],
    '笑う': ['笑顔', '微笑み', '笑い', 'smile', 'laugh'],
    '泣く': ['涙', '悲しい', '泣いている', 'cry', 'crying', 'tears'],
    '寂しい': ['孤独', '一人', '寂しさ', 'lonely', 'loneliness'],
    '不安': ['心配', '緊張', '恐れ', 'anxious', 'anxiety', 'nervous'],
    '緊張': ['不安', '心配', 'ドキドキ', 'nervous', 'tense'],
    '落ち着き': ['穏やか', 'リラックス', '平穏', 'calm', 'relaxed', 'peaceful'],

    // === 人物・属性 ===
    '女性': ['女', '女の人', '女子', '女の子', 'レディ', 'woman', 'female', 'lady', 'girl'],
    '男性': ['男', '男の人', '男子', '男の子', 'man', 'male', 'guy', 'boy'],
    '子供': ['子ども', 'こども', 'キッズ', '少年', '少女', 'child', 'kid', 'children'],
    '赤ちゃん': ['ベビー', '乳児', '赤子', 'baby', 'infant'],
    '老人': ['高齢者', 'お年寄り', 'シニア', 'elderly', 'senior', 'old'],
    'カップル': ['恋人', 'ペア', '二人', 'couple', 'lovers', 'pair'],
    '家族': ['ファミリー', '親子', 'family'],
    'ビジネスマン': ['サラリーマン', '会社員', 'ビジネス', 'businessman', 'office worker'],

    // === 動作・行動 ===
    '走る': ['走っている', 'ランニング', 'ジョギング', '駆ける', 'run', 'running', 'jog'],
    '歩く': ['歩いている', 'ウォーキング', '散歩', 'walk', 'walking'],
    '座る': ['座っている', '腰掛ける', 'sit', 'sitting'],
    '立つ': ['立っている', '起立', 'stand', 'standing'],
    '話す': ['会話', 'トーク', '喋る', 'おしゃべり', 'talk', 'speak', 'conversation'],
    '食べる': ['食事', '食べている', 'eating', 'eat', 'meal'],
    '飲む': ['飲んでいる', 'ドリンク', 'drink', 'drinking'],
    '働く': ['仕事', '作業', 'ワーク', 'work', 'working'],
    '踊る': ['ダンス', '踊っている', 'dance', 'dancing'],
    '歌う': ['歌', '歌っている', 'sing', 'singing'],
    '寝る': ['睡眠', '眠る', '就寝', 'sleep', 'sleeping'],
    '読む': ['読書', '読んでいる', 'read', 'reading'],
    '書く': ['書いている', 'ライティング', 'write', 'writing'],

    // === 場所・シーン ===
    '海': ['ビーチ', '海岸', '海辺', '浜辺', 'オーシャン', 'sea', 'ocean', 'beach'],
    '山': ['山岳', '山頂', 'マウンテン', 'mountain'],
    '森': ['森林', '林', 'ウッド', 'forest', 'woods'],
    '街': ['都市', '都会', '町', 'シティ', 'city', 'town', 'urban'],
    '東京': ['トーキョー', '都内', '首都', 'tokyo'],
    'オフィス': ['会社', '職場', 'ビジネス', 'office', 'workplace'],
    'カフェ': ['喫茶店', 'コーヒーショップ', 'cafe', 'coffee shop'],
    'レストラン': ['飲食店', '食堂', 'restaurant'],
    '家': ['自宅', '住宅', '部屋', 'home', 'house', 'room'],
    '空': ['青空', '夕焼け', '朝焼け', '雲', 'sky'],
    '夜': ['夜景', 'ナイト', '夜間', 'night', 'nighttime'],
    '朝': ['朝日', '早朝', 'モーニング', 'morning'],

    // === 自然・天候 ===
    '雨': ['雨降り', '雨天', 'レイン', 'rain', 'rainy'],
    '雪': ['降雪', '雪景色', 'スノー', 'snow', 'snowy'],
    '風': ['強風', 'そよ風', 'ウィンド', 'wind', 'windy'],
    '晴れ': ['快晴', '晴天', 'サニー', 'sunny', 'clear'],
    '桜': ['さくら', 'サクラ', '花見', 'cherry blossom', 'sakura'],
    '紅葉': ['もみじ', '秋', 'autumn leaves', 'fall'],
    '花': ['フラワー', '花々', 'flower', 'flowers'],
    '緑': ['グリーン', '新緑', '植物', 'green', 'greenery'],

    // === テクノロジー・ビジネス ===
    'テクノロジー': ['技術', 'IT', 'デジタル', 'ハイテク', 'technology', 'tech', 'digital'],
    'パソコン': ['PC', 'コンピューター', 'ラップトップ', 'computer', 'laptop'],
    'スマホ': ['スマートフォン', '携帯', 'モバイル', 'smartphone', 'mobile', 'phone'],
    'ミーティング': ['会議', '打ち合わせ', 'meeting', 'conference'],
    'プレゼン': ['プレゼンテーション', '発表', 'presentation'],

    // === 食べ物・料理 ===
    '料理': ['食事', 'クッキング', '調理', 'cooking', 'food', 'meal'],
    'コーヒー': ['珈琲', 'カフェ', 'coffee'],
    'お酒': ['アルコール', 'ドリンク', '飲み物', 'alcohol', 'drink'],

    // === アート・クリエイティブ ===
    'アート': ['芸術', '美術', '作品', 'art', 'artistic'],
    'デザイン': ['design', 'graphic'],
    'ファッション': ['服', '洋服', 'コーデ', 'fashion', 'clothes', 'style'],
    '音楽': ['ミュージック', '曲', '演奏', 'music', 'musical'],

    // === 動物 ===
    '犬': ['イヌ', 'ドッグ', 'わんこ', 'dog', 'puppy'],
    '猫': ['ネコ', 'キャット', 'にゃんこ', 'cat', 'kitten'],
    '鳥': ['バード', '小鳥', 'bird'],
    '動物': ['アニマル', 'ペット', 'animal', 'pet'],

    // === 抽象概念 ===
    '美しい': ['綺麗', 'キレイ', '美', 'ビューティフル', 'beautiful', 'pretty'],
    'かわいい': ['可愛い', 'キュート', 'cute', 'adorable'],
    'かっこいい': ['格好いい', 'クール', 'cool', 'handsome'],
    '速い': ['高速', 'スピード', 'ファスト', 'fast', 'quick', 'speed'],
    '静か': ['静寂', '穏やか', 'quiet', 'silent', 'peaceful'],

    // === 時間帯 ===
    '夕方': ['夕暮れ', '夕焼け', 'サンセット', 'evening', 'sunset'],
    '深夜': ['真夜中', 'ミッドナイト', 'midnight', 'late night']
  };

  // 逆引き辞書を生成（パフォーマンス向上のため）
  const REVERSE_SYNONYMS = {};
  Object.entries(SYNONYM_DICTIONARY).forEach(([key, synonyms]) => {
    synonyms.forEach(synonym => {
      if (!REVERSE_SYNONYMS[synonym.toLowerCase()]) {
        REVERSE_SYNONYMS[synonym.toLowerCase()] = [];
      }
      REVERSE_SYNONYMS[synonym.toLowerCase()].push(key);
    });
  });

  /**
   * 検索クエリを類義語で展開
   * @param {string} query - 元の検索クエリ
   * @returns {string} - 展開されたクエリ（OR検索用）
   */
  function expandQueryWithSynonyms(query) {
    if (!query) return query;

    const words = query.trim().split(/\s+/);
    const expandedTerms = new Set(words);

    words.forEach(word => {
      const wordLower = word.toLowerCase();

      // 直接一致する類義語を追加
      if (SYNONYM_DICTIONARY[word]) {
        SYNONYM_DICTIONARY[word].forEach(syn => expandedTerms.add(syn));
      }

      // 逆引きで関連キーワードを追加
      if (REVERSE_SYNONYMS[wordLower]) {
        REVERSE_SYNONYMS[wordLower].forEach(key => {
          expandedTerms.add(key);
          // その関連語も追加
          if (SYNONYM_DICTIONARY[key]) {
            SYNONYM_DICTIONARY[key].slice(0, 3).forEach(syn => expandedTerms.add(syn));
          }
        });
      }
    });

    return Array.from(expandedTerms).join(' OR ');
  }

  /**
   * 関連する検索キーワードを取得
   * @param {string} query - 検索クエリ
   * @returns {Array} - 関連キーワードの配列
   */
  function getRelatedKeywords(query) {
    if (!query) return [];

    const words = query.trim().split(/\s+/);
    const related = new Set();

    words.forEach(word => {
      const wordLower = word.toLowerCase();

      // 類義語を追加
      if (SYNONYM_DICTIONARY[word]) {
        SYNONYM_DICTIONARY[word].slice(0, 5).forEach(syn => related.add(syn));
      }

      // 逆引きからも追加
      if (REVERSE_SYNONYMS[wordLower]) {
        REVERSE_SYNONYMS[wordLower].forEach(key => related.add(key));
      }
    });

    // 元のクエリは除外
    words.forEach(word => related.delete(word));

    return Array.from(related).slice(0, 8);
  }

  // ===========================================
  // サンプルサジェストデータ
  // ===========================================
  const sampleSuggestions = [
    '海 夕焼け',
    '東京 夜景',
    '料理動画',
    '自然 風景',
    'カフェ 撮影',
    'ビジネス プレゼン',
    '美容 メイク',
    'フィットネス ヨガ',
    'ペット 動物',
    '季節 桜'
  ];
  
  class EnhancedSearch {
    constructor() {
      // .v0-searchがフォームそのもの（formタグ）
      this.searchForm = document.querySelector('.v0-search');
      this.searchInput = document.querySelector('.v0-search__input');
      if (!this.searchForm || !this.searchInput) return;

      this.init();
    }
    
    init() {
      this.createSuggestContainer();
      this.loadSearchHistory();
      this.attachEventListeners();
    }
    
    createSuggestContainer() {
      // サジェスト用のコンテナを作成
      const container = document.createElement('div');
      container.className = 'v0-search-suggest';
      container.innerHTML = `
        <div class="v0-suggest-section v0-suggest-history" style="display:none;">
          <div class="v0-suggest-label">検索履歴</div>
          <div class="v0-suggest-items" id="searchHistory"></div>
        </div>
        <div class="v0-suggest-section v0-suggest-popular" style="display:none;">
          <div class="v0-suggest-label">人気の検索</div>
          <div class="v0-suggest-items" id="popularSearches"></div>
        </div>
        <div class="v0-suggest-section v0-suggest-related" style="display:none;">
          <div class="v0-suggest-label">関連キーワード</div>
          <div class="v0-suggest-items" id="relatedKeywords"></div>
        </div>
        <div class="v0-suggest-section v0-suggest-results" style="display:none;">
          <div class="v0-suggest-label">検索候補</div>
          <div class="v0-suggest-items" id="searchSuggestions"></div>
        </div>
      `;
      
      this.searchForm.parentElement.style.position = 'relative';
      this.searchForm.parentElement.appendChild(container);
      this.suggestContainer = container;
    }
    
    loadSearchHistory() {
      const history = JSON.parse(localStorage.getItem('searchHistory') || '[]');
      this.searchHistory = history;
    }
    
    saveToHistory(query) {
      if (!query.trim()) return;
      
      // 重複を削除して先頭に追加
      this.searchHistory = this.searchHistory.filter(item => item !== query);
      this.searchHistory.unshift(query);
      
      // 最大件数を超えたら削除
      if (this.searchHistory.length > MAX_HISTORY_ITEMS) {
        this.searchHistory = this.searchHistory.slice(0, MAX_HISTORY_ITEMS);
      }
      
      localStorage.setItem('searchHistory', JSON.stringify(this.searchHistory));
    }
    
    attachEventListeners() {
      // 入力フィールドのフォーカス時
      this.searchInput.addEventListener('focus', () => {
        this.showSuggestions();
      });
      
      // 入力時
      this.searchInput.addEventListener('input', (e) => {
        const query = e.target.value;
        if (query.length > 0) {
          this.showSearchSuggestions(query);
        } else {
          this.showSuggestions();
        }
      });
      
      // フォーカスが外れた時（少し遅延を入れてクリックを処理できるように）
      this.searchInput.addEventListener('blur', () => {
        setTimeout(() => {
          this.hideSuggestions();
        }, 200);
      });
      
      // フォーム送信時 - Enterキーでの送信を防止（マウス選択必須）
      this.searchForm.addEventListener('submit', (e) => {
        // サジェストが表示されている場合はEnterキーでの送信を防止
        // ユーザーはマウスでサジェストを選択する必要がある
        if (this.suggestContainer.classList.contains('active')) {
          e.preventDefault();
          return;
        }

        // 直接入力からの検索（サジェストが閉じている場合）
        const originalQuery = this.searchInput.value.trim();
        if (originalQuery) {
          this.saveToHistory(originalQuery);
          // 類義語展開なしで元のクエリのみで検索
          // sessionStorageに元のクエリを保存
          sessionStorage.setItem('originalSearchQuery', originalQuery);
        }
      });
      
      // サジェストアイテムのクリック処理
      this.suggestContainer.addEventListener('click', (e) => {
        const item = e.target.closest('.v0-suggest-item');
        if (item) {
          const query = item.textContent;
          this.searchInput.value = query;
          this.saveToHistory(query);
          this.searchForm.submit();
        }
        
        const clearBtn = e.target.closest('.v0-clear-history');
        if (clearBtn) {
          this.clearHistory();
        }
      });
    }
    
    showSuggestions() {
      // 検索履歴を表示
      if (this.searchHistory.length > 0) {
        const historySection = this.suggestContainer.querySelector('.v0-suggest-history');
        const historyContainer = document.getElementById('searchHistory');
        
        historyContainer.innerHTML = this.searchHistory.map(item => `
          <div class="v0-suggest-item">
            <svg class="v0-suggest-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="11" cy="11" r="8"/>
              <path d="m21 21-4.35-4.35"/>
            </svg>
            <span>${this.escapeHtml(item)}</span>
          </div>
        `).join('') + `
          <button class="v0-clear-history">履歴をクリア</button>
        `;
        
        historySection.style.display = 'block';
      }
      
      // 人気の検索を表示
      const popularSection = this.suggestContainer.querySelector('.v0-suggest-popular');
      const popularContainer = document.getElementById('popularSearches');
      
      const popularSearches = sampleSuggestions.slice(0, 3);
      popularContainer.innerHTML = popularSearches.map(item => `
        <div class="v0-suggest-item">
          <svg class="v0-suggest-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
          </svg>
          <span>${this.escapeHtml(item)}</span>
        </div>
      `).join('');
      
      popularSection.style.display = 'block';
      
      this.suggestContainer.classList.add('active');
    }
    
    showSearchSuggestions(query) {
      // 検索候補を表示
      const resultsSection = this.suggestContainer.querySelector('.v0-suggest-results');
      const suggestContainer = document.getElementById('searchSuggestions');
      const relatedSection = this.suggestContainer.querySelector('.v0-suggest-related');
      const relatedContainer = document.getElementById('relatedKeywords');

      // 簡単なフィルタリング（実際はサーバーサイドで行う）
      const suggestions = sampleSuggestions.filter(item =>
        item.toLowerCase().includes(query.toLowerCase())
      );

      if (suggestions.length > 0) {
        suggestContainer.innerHTML = suggestions.slice(0, 5).map(item => `
          <div class="v0-suggest-item">
            <svg class="v0-suggest-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="11" cy="11" r="8"/>
              <path d="m21 21-4.35-4.35"/>
            </svg>
            <span>${this.highlightMatch(item, query)}</span>
          </div>
        `).join('');

        resultsSection.style.display = 'block';
      } else {
        resultsSection.style.display = 'none';
      }

      // 関連キーワードを表示（類義語辞書から取得）
      const relatedKeywords = getRelatedKeywords(query);
      if (relatedKeywords.length > 0) {
        relatedContainer.innerHTML = relatedKeywords.map(keyword => `
          <div class="v0-suggest-item v0-suggest-item--related">
            <svg class="v0-suggest-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
              <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
            </svg>
            <span>${this.escapeHtml(keyword)}</span>
          </div>
        `).join('');
        relatedSection.style.display = 'block';
      } else {
        relatedSection.style.display = 'none';
      }

      // 履歴セクションを非表示
      this.suggestContainer.querySelector('.v0-suggest-history').style.display = 'none';
      this.suggestContainer.querySelector('.v0-suggest-popular').style.display = 'none';

      this.suggestContainer.classList.add('active');
    }
    
    hideSuggestions() {
      this.suggestContainer.classList.remove('active');
      setTimeout(() => {
        this.suggestContainer.querySelectorAll('.v0-suggest-section').forEach(section => {
          section.style.display = 'none';
        });
      }, 200);
    }
    
    clearHistory() {
      this.searchHistory = [];
      localStorage.removeItem('searchHistory');
      this.showSuggestions();
    }
    
    escapeHtml(str) {
      const div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }
    
    highlightMatch(text, query) {
      const regex = new RegExp(`(${query})`, 'gi');
      return text.replace(regex, '<strong>$1</strong>');
    }
  }
  
  // ===========================================
  // 検索結果ページの拡張（0件時の関連結果表示）
  // ===========================================
  class SearchResultsEnhancer {
    constructor() {
      // 検索結果ページかどうかチェック
      if (!window.location.pathname.includes('/search')) return;

      this.init();
    }

    init() {
      // ページ読み込み完了後に実行
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.checkAndEnhanceResults());
      } else {
        this.checkAndEnhanceResults();
      }
    }

    checkAndEnhanceResults() {
      // 少し遅延を入れてDOMが完全に読み込まれるのを待つ
      setTimeout(() => {
        // 結果が0件かどうかをチェック
        let isZeroResults = false;

        // 方法1: ページテキストに"0件"や"見つかりませんでした"が含まれるかチェック
        const pageText = document.body.innerText || '';
        if (pageText.includes('見つかりませんでした') || pageText.includes('0件の結果')) {
          isZeroResults = true;
        }

        // 方法2: v0-cardが1つもないかチェック
        const cards = document.querySelectorAll('.v0-card:not(.v0-card--related)');
        if (cards.length === 0) {
          isZeroResults = true;
        }

        console.log('[SearchEnhancer] 0件チェック:', isZeroResults, 'cards:', cards.length);

        if (isZeroResults) {
          this.fetchRelatedResults();
        }
      }, 500);
    }

    getSearchQuery() {
      // URLから検索クエリを取得
      const params = new URLSearchParams(window.location.search);
      return params.get('q') || '';
    }

    async fetchRelatedResults() {
      const query = this.getSearchQuery();
      if (!query) return;

      console.log('[SearchEnhancer] 0件検出、関連結果を検索中:', query);

      // クエリを単語に分割
      const words = query.trim().split(/\s+/);

      // 各単語と類義語で検索
      const allResults = [];
      const seenHandles = new Set();

      for (const word of words) {
        // 元のキーワードで検索
        const results = await this.searchProducts(word);
        results.forEach(product => {
          if (!seenHandles.has(product.handle)) {
            seenHandles.add(product.handle);
            allResults.push(product);
          }
        });

        // 類義語でも検索
        const relatedKeywords = getRelatedKeywords(word);
        for (const related of relatedKeywords.slice(0, 2)) {
          const relatedResults = await this.searchProducts(related);
          relatedResults.forEach(product => {
            if (!seenHandles.has(product.handle)) {
              seenHandles.add(product.handle);
              allResults.push(product);
            }
          });
        }
      }

      if (allResults.length > 0) {
        this.displayRelatedResults(allResults, query);
      }
    }

    async searchProducts(keyword) {
      try {
        // 検索ページをHTMLで取得してパース
        const response = await fetch(`/search?q=${encodeURIComponent(keyword)}&type=product`);
        if (!response.ok) return [];

        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // 商品カードを抽出（データ属性から情報を取得）
        const cards = doc.querySelectorAll('.v0-card[data-product-handle]');
        const products = [];

        cards.forEach(card => {
          const handle = card.dataset.productHandle;
          const title = card.dataset.title || '';
          const preview = card.dataset.preview || '';

          if (handle) {
            // プレビューURLからサムネイルURLを生成
            let thumbnail = '';
            if (preview) {
              // watermarked/xxx_preview.mp4 → thumbs/xxx_thumb.webp
              thumbnail = preview
                .replace('/watermarked/', '/thumbs/')
                .replace('_preview.mp4', '_thumb.webp');
            }

            products.push({
              handle: handle,
              title: title,
              image: thumbnail,
              url: `/products/${handle}`
            });
          }
        });

        console.log(`[SearchEnhancer] "${keyword}" で ${products.length} 件発見`);
        return products;
      } catch (error) {
        console.error('[SearchEnhancer] 検索エラー:', error);
        return [];
      }
    }

    displayRelatedResults(products, originalQuery) {
      console.log('[SearchEnhancer] 関連結果:', products.length, '件');

      // 既存の"見つかりませんでした"メッセージを探す
      const noResultsSection = document.querySelector('.v0-no-results, [class*="no-result"]');
      const mainContent = document.querySelector('.v0-grid, main, .page-content');

      // 関連結果セクションを作成
      const relatedSection = document.createElement('div');
      relatedSection.className = 'v0-related-results';
      relatedSection.innerHTML = `
        <div class="v0-related-header" style="margin: 2rem 0 1rem; padding: 0 1rem;">
          <h3 style="color: var(--text-primary, #fff); font-size: 1.2rem; margin-bottom: 0.5rem;">
            「${this.escapeHtml(originalQuery)}」に関連する動画
          </h3>
          <p style="color: var(--text-secondary, #888); font-size: 0.9rem;">
            個別のキーワードで見つかった関連コンテンツです
          </p>
        </div>
        <div class="v0-grid" style="display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 1rem; padding: 0 1rem;">
          ${products.slice(0, 12).map(product => this.createProductCard(product)).join('')}
        </div>
      `;

      // 挿入位置を決定
      if (noResultsSection) {
        noResultsSection.after(relatedSection);
      } else if (mainContent) {
        mainContent.appendChild(relatedSection);
      } else {
        document.querySelector('main')?.appendChild(relatedSection);
      }
    }

    createProductCard(product) {
      const image = product.image || product.featured_image?.url || '/cdn/shop/files/placeholder.webp';
      const url = product.url || `/products/${product.handle}`;

      return `
        <a href="${url}" class="v0-card v0-card--related" style="
          display: block;
          background: var(--card-bg, #1a1a1a);
          border-radius: 12px;
          overflow: hidden;
          text-decoration: none;
          transition: transform 0.2s ease;
        ">
          <div class="v0-card__thumbnail" style="
            position: relative;
            padding-top: 56.25%;
            background: #000;
          ">
            <img src="${image}" alt="${this.escapeHtml(product.title)}" style="
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              object-fit: cover;
            " loading="lazy">
          </div>
          <div class="v0-card__info" style="padding: 0.75rem;">
            <h4 style="
              color: var(--text-primary, #fff);
              font-size: 0.9rem;
              margin: 0;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            ">${this.escapeHtml(product.title)}</h4>
          </div>
        </a>
      `;
    }

    escapeHtml(str) {
      if (!str) return '';
      const div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }
  }

  // DOMContentLoaded時に初期化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new EnhancedSearch();
      new SearchResultsEnhancer();
    });
  } else {
    new EnhancedSearch();
    new SearchResultsEnhancer();
  }
})();